<template>
  <!-- 用户详情-转赠记录 -->
  <div>
    <el-form :inline="true" :model="query" class="demo-form-inline">
      <el-form-item>
        <el-select v-model="query.to_user_id" placeholder="状态">
          <el-option :value="undefined">全部</el-option>
          <el-option :value="114024" label="朝歌"></el-option>
          <el-option :value="206896" label="官方"></el-option>
          <el-option :value="174321" label="金铲铲"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="query.status" placeholder="状态">
          <el-option :value="undefined">全部</el-option>
          <el-option :value="0" label="未处理"></el-option>
          <el-option :value="1" label="已处理"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-col class="pull-left" style="width: 220px; margin-right: 20px">
          <el-date-picker
              v-model="query.start_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="起始时间"
          >
          </el-date-picker>
        </el-col>
        <el-col class="pull-left" style="width: 220px; margin-right: 20px">
          <el-date-picker
              v-model="query.end_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="起始时间"
          >
          </el-date-picker>
        </el-col>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="getTableData">确定</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="from_user_id" label="来自" width="240px"></el-table-column>
      <el-table-column prop="to_user_id" label="转增给" width="240px"></el-table-column>
      <el-table-column prop="amount" label="金额" width="240px"></el-table-column>
      <el-table-column prop="created_at" label="时间" sortable></el-table-column>
      <el-table-column prop="status" label="状态" :filters="[
        { text: '未处理', value: 0 },
        { text: '已处理', value: 1 },
      ]" :filter-method="filterStatus">
        <template slot-scope="{ row }">
          <span v-if="row.status === 0">未处理</span>
          <span v-if="row.status === 1">已处理</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="350px">
        <template slot-scope="{ row }">
          <el-row v-if="row.status == 0 && row.to_user_id == 206896">
            <el-button type="primary" @click="setStatus(row, 1)"
            >已处理
            </el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
      :current-page="query.page" @current-change="handlePageChange"></el-pagination>
  </div>
</template>

<script>
import {getData, patchData} from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,
      query: {//查询条件
        page: 1,
        to_user_id: undefined,
        user_id: undefined,
        status: undefined,
        start_time: undefined,
        end_time: undefined,
      },
      dataList: undefined,
      dataMeta: {},
    }
  },

  methods: {
    getTableData() {
      this.loading = true
      let params = this.query
      getData(`transfer_log`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    setStatus(row, status) {
      let params = {
        id: row.id,
        status: status
      }
      patchData(`set_transfer`, params)
        .then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.visibleChange = false
            this.getTableData()
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    filterPayType(value, row, column) {
      //筛选充值方式
      const property = column['property'];
      return row[property] === value;
    },
    filterStatus(value, row, column) {
      //筛选订单状态
      const property = column['property'];
      return row[property] === value;
    },
    handlePageChange(page) {
      this.query.page = page
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>

</style>
